<div class="plugins-container">
  <div class="pre-installed-plugins">
    <div class="pre-installed-plugins__header-wrap">
      <div>
        <h3 class="pre-installed-plugins__title">Pre-installed plugins</h3>
        <p class="pre-installed-plugins__description">Select plugins from the WordPress repository to auto-install on client sites.</p>
      </div>
      <div class="plugins-actions">
        <button class="ds-btn ds-btn-black save-button" [style.width]="132+'px'"
                [disabled]="isSaving" (click)="savePlugins()">
            <db-loading-circular-spinner *ngIf="isSaving"></db-loading-circular-spinner>
            <span *ngIf="!isSaving">Save</span>
        </button>
      </div>
    </div>

    <div class="pre-installed-plugins__search">
      <div class="ds-input-wrap">
        <div class="custom-dropdown-container">
          <div class="custom-dropdown-input-wrapper">
            <div class="search-icon">
              <i class="db-icon db-icon-ds-glass"></i>
            </div>
            <input
              type="text"
              [formControl]="searchTerm"
              [placeholder]="'text_searchAddPlugins' | dbText"
              class="custom-dropdown-input"
              (focus)="onSearchInputFocus()"
              (click)="onSearchInputFocus()"
              [disabled]="isSearching"
            />
            <img src="../../../assets/images/loading/spinner-dotted.svg" *ngIf="isSearching"/>
          </div>

          <!-- Custom dropdown -->
          <div class="custom-dropdown-results" [ngClass]="{'db-empty': searchTerm.value && searchResults.length === 0}" *ngIf="showDropdown && !isSearching">
            <div *ngIf="!searchTerm.value" class="custom-dropdown-list">
              <!-- Show popular plugins when no search term -->
              <div *ngFor="let plugin of availablePlugins" class="custom-dropdown-item">
                <div class="custom-dropdown-item-content">
                  <div class="plugin-logo" [ngStyle]="{backgroundImage: 'url(' + plugin.logo + ')', backgroundSize: 'contain'}"></div>
                  <div class="plugin-info">
                    <div class="plugin-title" [innerHTML]="plugin.title"></div>
                    <div class="plugin-author" [innerHTML]="'By ' + plugin.author"></div>
                  </div>
                </div>
                <button class="choose-button" [ngClass]="{'installed': isPluginInMainList(plugin.slug)}" [disabled]="isPluginInMainList(plugin.slug)" (click)="choosePlugin(plugin)">{{ isPluginInMainList(plugin.slug) ? 'Added' : 'Choose' }}</button>
              </div>
            </div>

            <div *ngIf="searchTerm.value && searchResults.length === 0 && !isSearching" class="no-results">
                <i class="db-icon db-icon-ds-search-file"></i>
              <p>{{'text_noResultsWithThisQuery' | dbText}}</p>
            </div>

            <div *ngIf="searchTerm.value && searchResults.length > 0 && !isSearching" class="custom-dropdown-list">
              <div *ngFor="let plugin of searchResults" class="custom-dropdown-item">
                <div class="custom-dropdown-item-content">
                  <div class="plugin-logo" [ngStyle]="{backgroundImage: 'url(' + plugin.logo + ')', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}"></div>
                  <div class="plugin-info">
                    <div class="plugin-title" [innerHTML]="plugin.title"></div>
                    <div class="plugin-author" [innerHTML]="'By ' + plugin.author"></div>
                  </div>
                </div>
                <button class="choose-button" [ngClass]="{'installed': isPluginInMainList(plugin.slug)}" [disabled]="isPluginInMainList(plugin.slug)" (click)="choosePlugin(plugin)">{{ isPluginInMainList(plugin.slug) ? 'Installed' : 'Choose' }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Selected Plugins List -->
    <div class="selected-plugins" *ngIf="filteredPlugins?.length > 0">
      <div class="plugins-list-header">The following plugins will be pre-installed</div>

      <div class="plugins-list" [ngClass]="{'db-disabled': isSaving || isUpdatingList}">
        <db-loading-screen *ngIf="isUpdatingList"></db-loading-screen>
        <div *ngFor="let plugin of filteredPlugins" class="plugin-item plugin-item-list">
          <label class="db-product-item__logo noselect" [ngStyle]="{backgroundImage: 'url(' + plugin.logo + ')', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}" [ngClass]="{'showlogo': true}"></label>
          <div class="plugin-info">
            <div class="plugin-title" [innerHTML]="plugin.title"></div>
            <div class="plugin-author" [innerHTML]="'By ' + plugin.author"></div>
          </div>
          <div class="plugin-action">
            <div class="required-badge" *ngIf="requiredPlugins.includes(plugin.slug)">Required for site generation</div>
            <div class="action-buttons">
              <div class="preinstalled__checkbox" *ngIf="requiredPlugins.includes(plugin.slug)">
                <input class="ds-checkbox" type="checkbox" id="plugin-{{plugin.slug}}" [checked]="plugin.selected" (change)="togglePluginSelection(plugin)">
                <label for="plugin-{{plugin.slug}}" class="ds-checkbox-label black mb0">
                </label>
              </div>
              <p class="delete-button" *ngIf="!requiredPlugins.includes(plugin.slug)" (click)="deletePlugin(plugin)">Delete</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
